module.exports = __webpack_public_path__ + "pc/img/loupan.13515fff.png";